module.exports = __webpack_public_path__ + "img/adress.98264075.webp";